var _rect, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _ellipse3, _ellipse4, _ellipse5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNothingHere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 98,
    viewBox: "0 0 88 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.554688,
    width: 68,
    height: 70,
    rx: 8,
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5547,
    cy: 23,
    rx: 3,
    ry: 4,
    fill: "#1D2433"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.5547,
    cy: 23,
    rx: 3,
    ry: 4,
    fill: "#1D2433"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5474 44.4607C23.0411 41.4195 38.5259 38.3895 48.5153 50.5986",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5157 21.0847C14.3956 16.4972 19.9218 9.58682 26.9867 18.6448",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4821 17.9446C43.1594 15.7506 50.2315 12.1186 57.1008 15.1425",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79761 80.6159L5.7823 67.0639L11.7608 50.5198C12.9199 50.5889 13.8704 51.5676 14.2008 52.0483L14.3667 63.253L36.9338 58.5895L37.2004 59.9885C37.3071 60.5481 36.6608 61.5412 36.3243 61.9678L26.7032 65.9763C26.315 68.95 25.5441 75.1138 25.5659 75.9796C25.5876 76.8453 25.2697 77.2442 25.1081 77.3354L15.2476 81.0271C14.4281 81.4249 12.5273 82.1617 11.4798 81.9264C10.4323 81.6911 9.92186 80.9547 9.79761 80.6159Z",
    fill: "#C6C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.6674,
    y: 36.3528,
    width: 42.0831,
    height: 53.5392,
    rx: 3.5,
    transform: "rotate(11.142 44.6674 36.3528)",
    fill: "#F8F8F8",
    stroke: "#E1E6EF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48.9119,
    y1: 48.2456,
    x2: 78.9294,
    y2: 54.1577,
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 47.5603,
    y1: 55.1128,
    x2: 77.5778,
    y2: 61.0249,
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 46.2068,
    y1: 61.9839,
    x2: 76.2243,
    y2: 67.896,
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 44.8553,
    y1: 68.8511,
    x2: 74.8727,
    y2: 74.7631,
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 43.5017,
    y1: 75.7183,
    x2: 73.5192,
    y2: 81.6303,
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 42.1482,
    y1: 82.5855,
    x2: 72.1657,
    y2: 88.4975,
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.2092,
    cy: 66.5526,
    rx: 8.89736,
    ry: 2.73765,
    transform: "rotate(9.9661 78.2092 66.5526)",
    fill: "#C6C4C4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1799,
    cy: 70.7909,
    rx: 8.89736,
    ry: 2.73765,
    transform: "rotate(9.9661 77.1799 70.7909)",
    fill: "#C6C4C4"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.7913,
    cy: 74.7635,
    rx: 8.89736,
    ry: 2.73765,
    transform: "rotate(9.9661 75.7913 74.7635)",
    fill: "#C6C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingHere);
export default __webpack_public_path__ + "static/media/nothing-here.6f6ab071454cd07b7d4246f14148e2f1.svg";
export { ForwardRef as ReactComponent };